import { CustomInputMappingField } from "../../../redux/data/globalData/customInputMapping/customInputMappingActions";
import { JsonDataType } from "../JsonDataType";

//TODO: change to optional?
export type CustomInputValue = string | string[]

export const getCustomInputFieldValue = (fieldMapping: CustomInputMappingField, parsedJsonData: JsonDataType, aggregations?: JsonDataType): CustomInputValue | undefined => {
    if (fieldMapping.toAggregate && aggregations) {
        return aggregations[fieldMapping.aggregateField]
    }
    else {
        return parsedJsonData[fieldMapping.sourceField]
    }
}